import { render, staticRenderFns } from "./LoginFlowStepEmail.vue?vue&type=template&id=318e517e&scoped=true&"
import script from "./LoginFlowStepEmail.vue?vue&type=script&lang=ts&"
export * from "./LoginFlowStepEmail.vue?vue&type=script&lang=ts&"
import style0 from "./LoginFlowStepEmail.vue?vue&type=style&index=0&id=318e517e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318e517e",
  null
  
)

export default component.exports